import { logger } from "@/shared/lib/logger";
import type { AxiosInstance } from 'axios';
import { apiRoutes } from '@/shared/api/routes';
import type { RuntimeConfig, RuntimeConfigResponse, RuntimeConfigTuple } from '@/shared/types/runtimeConfig.types';

/**
 * List of all configuration keys to fetch from the API
 * Based on the existing app's configuration_fetch query
 */
const CONFIG_KEYS = [
//   "FORCE_RELOAD_HACK",
//   "analytics.directory.drt",
  "analytics.enabled",
//   "analytics.users",
//   "clientside.avt.noshowReasonKeys",
//   "component.alert.distanceUnits",
//   "component.archive.durationAtHome.enabled",
  "component.archive.fileStorage.maxSize",
//   "component.archive.postCreate.enabled",
  "component.centers.fundingSource.enabled",
  "component.clientbalance.enabled",
  "component.clientbalance.warninglimit",
//   "component.connect.enabled",
  "component.customfield.route.enabled",
  "component.dragAndDrop.enabled",
  "component.externalPaymentMethod.enabled",
  "component.externalPaymentMethod.addCard.enabled",
  "component.inspection.enabled",
  "component.ivr.enabled",
//   "component.mmis.enabled",
  "component.noShow.enabled",
//   "component.noShow.suspension.limit",
//   "component.noShow.warning.duration",
  "component.noShow.warning.limit",
  "component.noShow.warning.searchTimeRange",
  "component.outsourcing.enabled",
  "component.passwordPolicy.complexityHint",
  "component.passwordPolicy.maxLoginAttempts",
//   "component.persistence.customer.resolveHomeAddress",
  "component.rest.customerSearchDefaultOrderByEnabled",
//   "component.route.allowTripShiftForRealCluster",
  "component.route.checkTransportationProvider",
  "component.route.defaultDropoffMinusFlex",
  "component.route.defaultDropoffPlusFlex",
  "component.route.defaultFastPlusFlex",
  "component.route.defaultPickupMinusFlex",
  "component.route.defaultPickupPlusFlex",
  "component.route.defaultWillCallMinusFlex",
  "component.route.defaultWillCallPlusFlex",
  // External URL config keys (used by getDynamicAppRoutes in routes.ts)
  "component.vestige.url",
  "supervisor.frontend.primaryhost",
  "supervisor.feature.ediservice",
  "component.route.dropoffBaseDuration",
//   "component.route.dropoffSafetyMargin",
  "component.route.fareDistanceRoundingRule",
  "component.route.fareDurationRoundingRule",
  "component.route.fixedRouteDefaultStopDuration",
  "component.route.pickupBaseDuration",
//   "component.route.roadClass1",
//   "component.route.roadClass2",
//   "component.route.roadClass3",
//   "component.route.roadClass4",
  "component.route.markCompleteSynchronously.limit",
  "component.route.waitAndReturnEnabled",
  "component.rest.selfServicePickupWindowMinus",
  "component.rest.selfServicePickupWindowPlus",
  "component.rest.importPickupWindowMinus",
  "component.rest.importPickupWindowPlus",
  "component.rest.externalPickupWindowMinus",
  "component.rest.externalPickupWindowPlus",
  "component.rest.selfServiceDropoffWindowMinus",
  "component.rest.externalDropoffWindowMinus",
  "component.rest.importDropoffWindowMinus",
//   "component.smssending.SendSMS",
  "component.tripBasedUtilizationGraph.enabled",
  "component.tripcompletion.export.enabled",
//   "component.tripcompletion.import.enabled",
  "component.mileageReimbursement.enabled",
  "component.prepostverification.enabled",
//   "component.vehicle.idleDuration.enabled",
  "component.vestige.enabled",
  "component.negotiatedProviderRates.enabled",
  "component.route.returntrip.defaultReturnDelay",
  "component.requiredField.enabled",
  "component.archive.edit.SynchronizeFunding.enabled",
//   "general.age.child",
  "general.changeVehicleAllowedLimit",
  "general.currencyCode",
  "general.decision.extra1",
  "general.decision.extra1_default",
  "general.decision.extra1_label",
  "general.decision.extra1_set",
  "general.decision.extra2",
  "general.decision.extra2_default",
  "general.decision.extra2_label",
  "general.decision.extra2_set",
  "general.decision.extra3",
  "general.decision.extra3_default",
  "general.decision.extra3_label",
  "general.decision.extra3_set",
  "general.decision.extra4",
  "general.decision.extra4_default",
  "general.decision.extra4_label",
  "general.decision.extra4_set",
  "general.distanceUnits",
  "general.timezone",
  "general.enableChangeVehicleLimit",
  "general.enableClientBalanceWarning",
  "general.enableNegativeClientBalanceWarning",
  "general.external.data1_default",
  "general.external.data1_label",
  "general.external.data1_set",
  "general.external.data2_default",
  "general.external.data2_label",
  "general.external.data2_set",
  "general.external.data3_default",
  "general.external.data3_label",
  "general.external.data3_set",
  "general.external.data4",
  "general.external.data4_label",
  "general.external.data5",
  "general.external.data5_label",
  "general.provider.tripLimit.enabled",
  "general.provider.tripLimit.approachingLimit",
//   "general.provider.tripLimit.underLimit",
//   "component.mileageReimbursement.data1",
//   "component.mileageReimbursement.extra1_default",
//   "component.mileageReimbursement.extra1_label",
//   "component.mileageReimbursement.extra1_set",
//   "component.mileageReimbursement.data2",
//   "component.mileageReimbursement.extra2_default",
//   "component.mileageReimbursement.extra2_label",
//   "component.mileageReimbursement.extra2_set",
//   "component.mileageReimbursement.data3",
//   "component.mileageReimbursement.extra3_default",
//   "component.mileageReimbursement.extra3_label",
//   "component.mileageReimbursement.extra3_set",
  "component.mileageReimbursement.maxDaysInFuture",
  "component.mileageReimbursement.maxDaysInPast",
//   "component.auth.sso.evolution.signInURL",
//   "component.auth.sso.evolution.clientId",
//   "component.auth.sso.evolution.signInPolicy",
//   "component.auth.sso.evolution.loginButtonName",
//   "component.auth.sso.evolution.enabled",
  "component.eligibility.enabled",
  "general.external.externalTripIdEnabled",
//   "general.locale",
  "general.metersInMile",
  "general.profile.extra1_default",
  "general.profile.extra1_label",
  "general.profile.extra1_set",
  "general.profile.extra2_default",
  "general.profile.extra2_label",
  "general.profile.extra2_set",
  "general.profile.extra3_default",
  "general.profile.extra3_label",
  "general.profile.extra3_set",
  "general.profile.extra4_default",
  "general.profile.extra4_label",
  "general.profile.extra4_set",
  "general.profile.extra5_default",
  "general.profile.extra5_label",
  "general.profile.extra5_set",
  "general.profile.extra6_default",
  "general.profile.extra6_label",
  "general.profile.extra6_set",
  "general.profile.extra7_default",
  "general.profile.extra7_label",
  "general.profile.extra7_set",
  "general.profile.extra8_default",
  "general.profile.extra8_label",
  "general.profile.extra8_set",
//   "general.service_rules.travelAloneEnabled",
//   "general.preserveTargetRuns",
  "geocoding.country",
  "geocoding.state",
//   "na",
  "supervisor.admin.tab.fixroute.disabled",
  "supervisor.archive.trip.edit.maxchildren",
  "supervisor.archive.trip.edit.maxcompanions",
  "supervisor.archive.trip.edit.maxotherpassengers",
  // ECOPD-17020 — route "Lock for dispatch" gate. Mirrors legacy
  // comp_route_lock_for_dispatch = negate(supervisor.cluster.no-lock). Must be
  // fetched so a tenant that sets no-lock=1 (disable route locking) actually
  // hides the button; absent from this allowlist it was never fetched, so the
  // disable was silently a no-op (button always shown).
  "supervisor.cluster.no-lock",
  "supervisor.disable.driverIncident",
  "supervisor.disable.feedback",
//   "supervisor.email.reply.address",
  "supervisor.feature.stop-edit",
  "supervisor.gis.segment.nearby.xrange",
  "supervisor.gis.segment.nearby.yrange",
  "supervisor.location.codesearch.enabled",
  "supervisor.manual-dispatch.enabled",
//   "supervisor.manual.manifest.external.tripid",
//   "supervisor.mde.live.heading",
  "supervisor.mde.live.latitude",
  "supervisor.mde.live.longitude",
  "supervisor.mde.live.range",
//   "supervisor.mde.live.tilt",
  "supervisor.orderimport.enabled",
  "supervisor.otp.green",
  "supervisor.otp.red",
  "supervisor.otp.yellow",
//   "supervisor.route.fixedRouteTimeWindowLate",
    "supervisor.route.scheduling.violation.est.after.pp.limit.red",
    "supervisor.route.scheduling.violation.est.after.pp.limit.yellow",
    "supervisor.route.scheduling.violation.est.before.pp.limit.orange",
    "supervisor.run.status.display",
  "supervisor.selfservice.enabled",
//   "supervisor.service.hostname",
  "supervisor.subcontractor.defaultCancelType",
  "supervisor.tripgroup.max-clusters",
  "supervisor.tripgroup.max-passenger-in-run",
  "supervisor.tripgroup.max-wc-in-run",
  "supervisor.trips.acceptreject.lowerlimit_days",
  "supervisor.trips.acceptreject.upperlimit_days",
  "supervisor.trips.acceptreject.visibility",
  "supervisor.use_revenue_breaks",
  "supervisor.vehicle.flipseats",
  "supervisor.vehicle.flipwcs",
  "supervisor.vehicle.seats",
  "supervisor.vehicle.stretchers",
  "system.version.number",
  // ECOPD-17017 — configurable system/app name used as the browser tab title
  // suffix (e.g. "<page> - <general.system.name>"). Falls back to the tenant
  // branding appName, then "Ecolane Dispatch", when absent.
  "general.system.name",
  "web.ccagent.addressAutocompleteMaxResults",
//   "web.ccagent.backgroundColor",
  "web.ccagent.defaultDateOffset",
  "web.ccagent.extraStopDurations",
  "web.ccagent.feature.allowBillingCodeSelect",
  "web.ccagent.feature.defaultCancelType",
  "web.ccagent.feature.defaultConfirmCancelType",
  "web.ccagent.feature.defaultTimeType",
  "web.ccagent.feature.obTravelPurpose",
//   "web.ccagent.feature.onlyFixedStops",
  "web.ccagent.conv_base_url",
  "web.ccagent.feature.alphaBot",
  // ECOPD-16429 — per-agency gate for the Reboot -> Legacy Evolution fallback
  // ("Switch to older version"). Absent/false => control hidden (default OFF).
  "web.ccagent.feature.showRebootToLegacySwitch",
  // Target URL for the "Switch to older version" control (e.g.
  // https://demo-react.ecolane.com/drt). Falls back to supervisor.frontend.primaryhost.
  "rails.drt.baseUrl",
  "web.ccagent.feature.requireTransportationProvider",
  "web.ccagent.feature.routeForceAssign",
  // ECOPD-14979 — Phase 1 Reboot gate for Round Trip / Wait for Passenger (Linked Return Trip).
  // Absent from K3 config → isFeatureEnabled returns false → feature hidden (default).
  // Must be in this allowlist or the key is never fetched and the flag can never be turned on.
  "web.ccagent.feature.roundTripEnabled",
  "web.ccagent.feature.tripGroupsForTrips",
  "web.ccagent.feature.useCustomerHomeAddressAsPoi",
  "web.ccagent.feature.streetNumberSelector",
//   "web.ccagent.instanceName",
  "web.ccagent.providerOverrideWithoutFundingSourceDefault",
  // Schedules table trip cell: when true, hides Part 8 (time window) and Part 10 (passenger note).
  // Default: true (brief mode = hide time window). Tenants set to false to show the window.
  "use_route_brief_trips",
  // Schedules page: "Apply to all search results" checkbox in Mark Complete and Manual Dispatch tabs.
  // Default: true — the old Rails app shows this checkbox. Tenants set to false to hide it.
  "use_apply_all",
  // ECOPD-17020 — Run Status per-run "Lock runs for dispatch" tab. Mirrors the
  // legacy `use_run_lock` eco-feature (drt servers.yml). Absent from K3 config →
  // isFeatureEnabled returns false → the Lock tab is hidden (default OFF, matching
  // legacy). Tenants that enable it in legacy set this key truthy in K3 config.
  "use_run_lock",
];

/**
 * Default values for configuration keys that should have a non-false fallback
 * when the key is absent from the API response.
 * Used by `isFeatureEnabled` before consulting the live config.
 */
const CONFIG_DEFAULTS: Partial<Record<string, string | number | boolean>> = {
  // analytics.enabled — Pendo analytics gate.
  // In the legacy Rails app, eco_pendo_scripts() has the eco_component?(:comp_analytics)
  // check commented out (analytics_helper.rb:15), meaning Pendo was unconditionally enabled.
  // Default: true (opt-out model) — a tenant must explicitly set analytics.enabled=false
  // in the backend to disable Pendo for their instance.
  'analytics.enabled': true,
  // Legacy Rails default: eco_features.rb sets `street_number_selector: true` as a
  // hardcoded server-side initializer default (NOT a DB config key). The key is also
  // intentionally commented-out from JS_FEATURES (js_env_support.rb line 30), so it
  // is never sent to the frontend via the config API. The React runtime config lookup
  // therefore returns undefined → false, breaking the typeahead. Mirror the Rails
  // default here so behaviour is identical: the typeahead is on unless a tenant
  // explicitly sets web.ccagent.feature.streetNumberSelector=false in the DB.
  'web.ccagent.feature.streetNumberSelector': true,
  // Show the Trip Group select menu on New Order / Trip Details by default.
  // Tenants that want to hide it must set this to false in the backend.
  'web.ccagent.feature.tripGroupsForTrips': true,
  // Schedules table trip cell — Part 8 (time window) and Part 10 (passenger note).
  // Default: true = brief mode = hide the (Ear HH:MM Lat HH:MM) time window in the Trips column.
  // Tenants that want to show it must explicitly set use_route_brief_trips=false in backend config.
  // Without this default, the flag is absent → isFeatureEnabled returns false → Part 8 renders
  // in Full mode even though no tenant has enabled it (showing unexpected "Ear/Lat" labels).
  'use_route_brief_trips': true,
  // "Apply to all search results" checkbox in Mark Complete and Manual Dispatch tabs.
  // Default: true — the old Rails app always shows this checkbox. Tenants that want to hide it
  // must set use_apply_all=false in backend config. Without this default, the absent key returns
  // false → checkbox hidden even though the old app shows it.
  'use_apply_all': true,
};

/**
 * Creates the runtime configuration service
 */
export const createRuntimeConfigService = (apiClient: AxiosInstance) => {
  /**
   * Fetches runtime configuration from the API
   */
  const fetchConfiguration = async (): Promise<RuntimeConfig> => {
    try {
      const response = await apiClient.post<RuntimeConfigResponse>(
        apiRoutes.proxy('support/internal/configuration_fetch/select_query'),
        {
          select: ["key", "value"],
          query: [
            [
              "or",
              ["in", "key", CONFIG_KEYS],
              ["like", "key", "clientside.avt.noshowReasonValue%"]
            ]
          ],
          options: {
            limit: 0,
            calculate_total: false
          }
        }
      );

      // Transform array of [key, value] tuples into object
      const config: RuntimeConfig = {};
      
      if (response.data?.data && Array.isArray(response.data.data)) {
        response.data.data.forEach((tuple: RuntimeConfigTuple) => {
          // API returns array of tuples: [key, value]
          if (Array.isArray(tuple) && tuple.length >= 2) {
            const [key, value] = tuple;
            if (key) {
              config[key] = value;
            }
          }
        });
      }

      return config;
    } catch (error) {
      logger.error('Failed to fetch runtime configuration:', error);
      throw error;
    }
  };

  /**
   * Gets a configuration value by key with optional default
   */
  const getConfigValue = <T = string | number | boolean>(
    config: RuntimeConfig | null,
    key: string,
    defaultValue?: T
  ): T | undefined => {
    if (!config) return defaultValue;
    const value = config[key];
    // Treat empty-string as absent — a config entry that was cleared in the
    // backend (value === '') should fall through to the caller's defaultValue
    // rather than propagating '' as a numeric/boolean config result.
    return value !== undefined && value !== '' ? (value as T) : defaultValue;
  };

  /**
   * Checks if a feature is enabled.
   * Falls back to CONFIG_DEFAULTS when the key is absent from the live config.
   */
  const isFeatureEnabled = (
    config: RuntimeConfig | null,
    featureKey: string
  ): boolean => {
    const value = config?.[featureKey] ?? CONFIG_DEFAULTS[featureKey];

    if (value === undefined || value === null) return false;

    // Handle various truthy values
    if (typeof value === 'boolean') return value;
    if (typeof value === 'string') {
      return value.toLowerCase() === 'true' || value === '1' || value === 'yes';
    }
    if (typeof value === 'number') return value === 1;

    return false;
  };

  return {
    fetchConfiguration,
    getConfigValue,
    isFeatureEnabled,
  };
};

export type RuntimeConfigService = ReturnType<typeof createRuntimeConfigService>;
